var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gradient-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"notice-text"},[_vm._v("This artwork is exclusive and can only be purchased once. It will not be available on the site after purchase.")])])])])])
}]

export { render, staticRenderFns }